import styled from 'styled-components'

export const PageTitle = styled.h1`
    margin-top: 2rem;
    margin-bottom: 1.5rem;
`